import { app } from '../../../bootstrap/core';
import { progressComponent } from './progress.component';
import { ProgressService } from './progress.service';
import { progressTypes, typesToIconsMapping } from './progress.constants';

app.component('progressMeter', progressComponent);
app.service('progressService', ProgressService);
app.constant('progressTypes', progressTypes);
app.constant('typesToIconsMapping', typesToIconsMapping);